import { Component, Input } from '@angular/core';

@Component({
    selector: 'psm-header',
    templateUrl: 'headerWithRoute.component.html'
})

export class HeaderWithRouteComponent {
    @Input()
    public title: string;
}



// WEBPACK FOOTER //
// ./src/app/components/common/headerWithRoute/headerWithRoute.component.ts